import React from "react";
import HeaderThree from "../../Layouts/Headers/HeaderThree";
import InnerPageTitle from "../../Helpers/InnerPageTitle";
import FooterOne from "../../Layouts/Footers/FooterOne";
import MainWid from "./MainWid";
import BrandAreaWid from "../../Common/BrandAreaWid";
import HeaderOne from "../../Layouts/Headers/HeaderOne";

function ServiceDetails() {
  return (
    <>
      <HeaderThree />
      <main>
        <InnerPageTitle
          title="Service Details"
          paths={[
            { name: "Home", path: "/" },
            { name: "Services", path: "" },
            { name: "Skylight Services", path: "/services/services-skylight" },
          ]}
        />
        <MainWid />
        <BrandAreaWid className="pt-0" />
      </main>
      <FooterOne />
    </>
  );
}

export default ServiceDetails;
